import {
    INVALID_PASSWORD_CONFIRMATION,
    INVALID_PASSWORD_CONFIRMATION_LENGTH,
    VALID_PASSWORD_CONFIRMATION,
    VALID_PASSWORD_CONFIRMATION_LENGTH,
} from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (e, password) => (dispatch) => {
    const password_confirmation = e.target.value;

    if (password_confirmation.length >= 8) {
        dispatch(companyUsersActions[VALID_PASSWORD_CONFIRMATION_LENGTH]());
    } else {
        dispatch(companyUsersActions[INVALID_PASSWORD_CONFIRMATION_LENGTH]());
    }

    if (password_confirmation === password) {
        dispatch(companyUsersActions[VALID_PASSWORD_CONFIRMATION]());
    } else {
        dispatch(companyUsersActions[INVALID_PASSWORD_CONFIRMATION]());
    }
};
